<template>

  <!--Drawer-->
  <v-navigation-drawer app v-model="drawer">

    <!-- Avatar -->
    <v-container v-if="isLoggedIn" class="px-4">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-avatar size="100">
            <v-img :src="avatarUrl" referrerpolicy="no-referrer"></v-img>
          </v-avatar>
          <div class="font-weight-bold text-green-darken-4">
            {{ firstName }} {{ lastName }}
          </div>
          <div class="font-weight-thin text-disabled text-caption">
            {{ email }}
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!--Links-->
    <v-list lines="two">
      <v-list-item 
        v-for="link in filteredLinks" 
        :to="link.to"  
        :key="link.title" 
        :title="link.title"
      >
        <template v-slot:prepend>
          <v-icon>{{link.icon}}</v-icon>
        </template>
      </v-list-item>      

      <!-- <v-divider class="my-2"></v-divider> -->
      
    </v-list>

    <!-- <v-list>
      <v-list-subheader>Experimental</v-list-subheader>
      <v-list>
        <v-list-item 
          to="/questionnaire"  
          key="Questionnaire" 
          title="Questionnaire"
        >
        <template v-slot:prepend>
          <v-icon>mdi-format-list-bulleted</v-icon>
        </template>
      </v-list-item>
      </v-list>
    </v-list> -->
  </v-navigation-drawer>


  <!--App bar-->
  <v-app-bar>
    <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    <v-toolbar-title class="full-title text-h5 font-weight-light text-uppercase ml-n2">
      <span class="text-success">123</span><span class="">psy</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    
    <v-btn @click="toggleDarkTheme" icon>
      <v-icon>{{ isDark ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent' }}</v-icon>
    </v-btn>

    <v-btn variant="tonal" @click="signAction">
      <template v-if="isLoggedIn" >
        <v-icon start>mdi-logout</v-icon>
        <span class="text-none">{{ $t('psychologistNavbar.sign_out') }}</span>
      </template>
      <template v-else>
        <v-icon start>mdi-login</v-icon>
        <span class="text-none">{{ $t('psychologistNavbar.sign_in') }}</span>
      </template>
    </v-btn>
  </v-app-bar >


</template>

<script>
import { useTheme } from 'vuetify'
import apiService from '@/services/ApiService'

export default {
  name: 'NavBar',

  data() {
    return {
      drawer: false,
    }
  },  

  created() {
    this.theme = useTheme()
  },

  mounted() {
    // this.store.initAuth();
  },

  computed: {
    links() {
      return [
        // { title: 'Welcome', icon: 'mdi-home', to: '/', "protected": false },
        { title: this.$t('psychologistNavbar.dashboard'), icon: 'mdi-view-dashboard', to: '/psychologist/dashboard', "protected": true },
        { title: this.$t('psychologistNavbar.evaluations'), icon: 'mdi-clipboard-check-outline', to: '/psychologist/evaluations', "protected": true  },
        { title: this.$t('psychologistNavbar.clients'), icon: 'mdi-account-multiple', to: '/psychologist/clients', "protected": true  },
        { title: this.$t('psychologistNavbar.settings'), icon: 'mdi-cog-outline', to: '/psychologist/settings', "protected": true  },
        // { title: 'About', icon: 'mdi-information', to: '/about', "protected": false  },
        // { title: 'Evaluation', icon: 'mdi-clipboard-text', to: '/evaluation?token=D34T12823', "protected": true  },
        // { title: 'Logout', icon: 'mdi-login', to: '/login',"protected": true  },
      ];
    },

    filteredLinks() {
      return this.links.filter(link => {
        if (link.protected && !this.store.isLoggedIn) {
          return false;
        }
        return true;
      });
    },

    isLoggedIn() {
      return this.store.isLoggedIn;
    },

    firstName() {
      return this.store.user?.firstName || '';
    },

    lastName() {
      return this.store.user?.lastName || '';
    },  

    email() {
      return this.store.user?.email || '';
    },

    role() {
      return this.store.user?.role || 'guest';
    },  

    avatarUrl() {
      return this.store.user?.avatarUrl || '/images/logo.png';
    },

    isDark() {
      return this.store.darkTheme  // Read directly from store
    },
  },

  methods: {
    signAction() {
      if (this.isLoggedIn) {
        this.store.logout();
        apiService.clearToken();//This ends up being stored as (the string) "null". Ha!
        this.$router.push('/');
      } else {
        this.$router.push('/');
      }
    },

    toggleDarkTheme() {
      this.store.setDarkTheme(!this.store.darkTheme);
    },
  }
}
</script>

<style scoped>
/**This forces the text not to be shrunk*/
.full-title{
  flex: none;
}
</style>